define('modules/media/edge',['require','exports','module','modules/media/binder','app'],function(require, exports, module) {"use strict";

	var Binder = require("modules/media/binder");
	var app = require("app");
	//	var AdobeEdge = require("animate");
	//	var LoaderEdge = require("animate_loader");

	return module.exports = {

		edge : {},

		edgeCount : 0,

		load : function(el, media, elements, Global_callback) {

			//////console.log ('LOAD ', 'EDGE REQUEST' , el.id, media.id);

			this.check_events(el.id, media.id);
			if (!elements.getAttribute('data_loaded')) {

					//elements.setAttribute('data_loaded', true);
				var scaler = this.scaleStage;
				var forceplay = this.must_play;
				var rescaler=this.rescaler[el.id];
				
				
				
				
				
				
				
				//window.AdobeEdge.loadResources();
				//window.AdobeEdge.playWhenReady();
				
				
				
		
					elements.setAttribute('data_loaded', true);
				
			//	////console.log('-->',window.AdobeEdge.compositions ,window.AdobeEdge.compositionDefns);
				
						
						
						//window.AdobeEdge.getComposition(media.id).callReadyList();
				
				
			
					
					
					
					/* AdobeEdge.Symbol.bindTimelineAction(media.id, "stage", "Default Timeline", "complete", function(sym, e) {
					 	
					 	
					 	////console.log('--> readyOK',window.AdobeEdge.getComposition(media.id).readyCalled);
					 	
					 	
					 	
					 });*/
					
					
				
					window.AdobeEdge.Symbol.bindElementAction(media.id, "stage", "window", "compositionReady", function(sym, e) {
						
					//////console.log('--> readyOK2',window.AdobeEdge.getComposition(media.id).readyCalled);

								try {

									sym.onStart();
									
									//console.log('--> readyOK2');


								} catch(ex) {

								}

							});
				
				
				
				
				window.AdobeEdge.okToLaunchComposition( media.id);
				window.AdobeEdge.getComposition(media.id).callReadyList();
				
				
				
			
				var stage = window.AdobeEdge.getComposition(media.id).getStage();

					stage.$('Stage').css({
						"transform-origin" : "0 0",
						"-ms-transform-origin" : "0 0",
						"-webkit-transform-origin" : "0 0",
						"-moz-transform-origin" : "0 0",
						"-o-transform-origin" : "0 0",
						"width" : media.w + "px",
						"height" : media.h + "px"
					});
					
					scaler(media.id, media.w, media.h,rescaler);
				

				/*window.AdobeEdge.bootstrapCallback(function(compId) {

					////console.log ('redu ', 'InsideCallback');

					_.map(modules_cfg, function(elm) {

						if (elm.contents.type === 'animate') {

							//////////console.log ('>>>> ',elm.contents["edge-id"] ,compId);
							if (elm.contents["edge-id"] === compId[0]) {
								
								
								////console.log ('>>>> ',elm.contents["edge-id"] ,compId[0]);
 
								return document.getElementById(elm.contents["module-id"]).setAttribute('data_loaded', true);

							}
						}

					});
					//module-id

					var stage = window.AdobeEdge.getComposition(compId).getStage();

					stage.$('Stage').css({
						"transform-origin" : "0 0",
						"-ms-transform-origin" : "0 0",
						"-webkit-transform-origin" : "0 0",
						"-moz-transform-origin" : "0 0",
						"-o-transform-origin" : "0 0",
						"width" : media.w + "px",
						"height" : media.h + "px"
					});

					if (compId[0] === media.id) {

						//////console.log ('LOAD1 ', rescaler);
						scaler(media.id, media.w, media.h,rescaler);
						

						if (forceplay[media.id]) {

							window.AdobeEdge.Symbol.bindElementAction(media.id, "stage", "document", "compositionReady", function(sym, e) {

								try {

									sym.onStart();

								} catch(ex) {

								}

							});
							
							
							
							
							
							

						}

					}

				});*/

			} else {
				
					
				this.scaleStage(media.id, media.w, media.h,this.rescaler[el.id]);

				
				
				////console.log ('try start',this.must_play[media.id]);
				
				
				if (this.must_play[media.id]) {

					try {
						
							//////console.log ('try start');

						var sym = window.AdobeEdge.getComposition(media.id).getStage();
						sym.onStart();
					} catch(ex) {

					}

				}

			//	////console.log ('video già assegnato');

			}

			if (!(media.id in window.AdobeEdge.compositions) && !_.isEmpty(window.AdobeEdge.compositionDefns)) {

			//	////console.log ('BRUTAL ,  FORCE ANIMATE!');
				window.AdobeEdge.launchComposition(media.id);
				
				//////console.log ('LOAD3 ', this.rescaler);
				this.scaleStage(media.id, media.w, media.h,this.rescaler[el.id]);

				if (this.must_play[media.id]) {

					////////console.log ('BRUTAL ,  FORCE ANIMATE!',window.AdobeEdge);

					try {
						var sym = window.AdobeEdge.getComposition(media.id).getStage();
						sym.onStart();

					} catch(ex) {

						// //////console.log ('waiting',window.AdobeEdge);

					}
				}

			}

		},

		get_resource : function(elements, id) {

			try {

				this.js_src.comp[id] = document.getElementById(elements.id + '_composition').innerText;
				this.js_src.act[id] = document.getElementById(elements.id + '_action').innerText;

				eval(this.js_src.comp[id]);
				eval(this.js_src.act[id]);

				//	////////console.log ("-->",eval(t))

			} catch(err) {

			}

		},

		js_src : {

			comp : {},
			act : {},
			status : {},
			loaded : {}

		},

		must_play : {},
		must_leave : {},

		rewind : function(id, media) {

			//////////console.log ('MUST REWIND' , media,   id );

			if (this.must_leave[media]) {

				try {
					var sym = window.AdobeEdge.getComposition(media).getStage();
					sym.onLeave();

				} catch(er) {

				}
			}

		},

		check_events : function(id, media) {

			if ('events' in modules_cfg[id].properties) {

				if ("onEnter" in modules_cfg[id].properties.events) {

					//////////console.log ('MUST PLAY');
					this.must_play[media] = modules_cfg[id].properties.events.onEnter;

				}

				if ("onLeave" in modules_cfg[id].properties.events) {

					//////////console.log ('MUST LEAVE');

					this.must_leave[media] = modules_cfg[id].properties.events.onLeave;

				}

			}
			
			
			
			if ('forcedim' in modules_cfg[id].properties) {
						
					 // //////console.log ( id,'rescale',  modules_cfg[id].properties.forcedim);
						this.rescaler[id]= modules_cfg[id].properties.forcedim ;
						
					}
			
			
			
			

		},
		
		
		rescaler:{},
		
		Bind : function(modules_cfg, el, id) {

			//Binder.addEvent(this.edge, 'ended', this.edge_End);

		},

		Unbind : function(id) {

			/*	if (_.isUndefined(this.edge) || _.isNull(this.edge) || _.isEmpty(this.edge)) {

			 return;
			 }

			 Binder.removeEvent(this.poster, 'click', this.edge_Go);

			 Binder.removeEvent(this.edge, 'ended', this.edge_End);

			 //this.edge.onended=null;

			 this.edge = {};
			 this.poster = {};*/

		},

		onStart : function() {

		},

		onLeave : function() {

		},

		

		scaleStage : function(id, w, h, rescaler) {
			
			//return
			
			
			
			////console.log(AdobeEdge.getComposition(id))
			
			var get_view_res = function() {
			var e = window;
			var a = 'inner';
			if (!('innerWidth' in window)) {
				a = 'client';
				e = document.documentElement || document.body;
			}
			return {
				w : e[a + 'Width'],
				h : e[a + 'Height']
			};
		};
			
			
			

			var go = true;

			// (_.isUndefined(AdobeEdge.getComposition(id)))

		
			
			var topSpace=0;
			
			var checkori=false;
			
			
			

			if (!_.isUndefined(AdobeEdge.getComposition(id))) {
				
				
				
				if("revert"  in rescaler ){
					
					if (rescaler.revert){
						checkori=true;
					
						
							AdobeEdge.getComposition(id).getStage().changeOri(get_view_res().w,get_view_res().h);
						
						
					}
					
					
					
				}
				
			
				
				
				var stage = AdobeEdge.getComposition(id).getStage().$('Stage');
				// Set a reusable variable to reference the stage
				var parent = stage.parent();
				
				
				//////console.log("parent", stage  , parent, parent.height() ,get_view_res().h )
				// Set a reusable variable to reference the parent container of the stage
				var parentWidth =  get_view_res().w;  //parent.width();
				// Get the parent of the stage width
				var parentHeight =  get_view_res().h;//parent.height();
				// Get the browser window height
				var stageWidth = stage.width() == 0 ? w : stage.width();
				// Get the stage width
				var stageHeight =stage.height() == 0 ? h : stage.height();
				// Get the stage height
				var desiredWidth =    Math.round(parentWidth * 1);
				// Set the new width of the stage as it scales
				var desiredHeight = Math.round(parentHeight * 1);
				// Set the new height of the stage as it scales
					
					
					
					
						if(checkori &&  get_view_res().h>get_view_res().w ){
						
						////console.log("REVERT")
						stageWidth =h;
						 stageHeight =w;
					/*	desiredWidth =get_view_res().h;
						desiredHeight =get_view_res().w;
						
						rescale = (desiredHeight / stageHeight);*/
						
					}else{

           stageWidth = w;
            stageHeight = h;

        }
					
					
					
						////console.log ('ST' , AdobeEdge.getComposition(id).getStage().getSymbolElement().height() )
					
					
				
				if(!_.isUndefined(rescaler) && !_.isEmpty(rescaler)  && !_.isNull(rescaler)  &&  !_.isUndefined(app.ViewType)    ){
					
					
					
					
					
					
					
						
					 
					  if (!('name' in  app.ViewType) ){
					  	
					  	return;
					  }
						
						    if ("topMarginPx" in rescaler  && app.ViewType.name==='yotta' ){
						    	
						    	if (_.isNumber(rescaler.topMarginPx)){
						    		
						    		
						    		
						    		desiredHeight=desiredHeight-rescaler.topMarginPx;
						    		topSpace=rescaler.topMarginPx;
						    		
						    		parentHeight=parentHeight +topSpace;
						    		
						    		
						    		
						    	}
						    	
						    	
						     }
						     
						     
						    // console.info('In' ,app.ViewType.name,"globalPerc" in rescaler);&& app.ViewType.name!='yotta'
						     
						      if ("globalPerc" in rescaler   ){
						    	
						    	if (_.isNumber(rescaler.globalPerc )){
						    		
						    		
						    		desiredWidth=desiredWidth-(desiredWidth*rescaler.globalPerc )/100;
						    	}
						    	
						    	
						     }
						     
						    
						    
						
						
					}
				
				
				
				
			
				
				
				
				
				
				
				
				
				
				var rescaleWidth = (desiredWidth / stageWidth);
				
				
		
				
				
				// Set a variable to calculate the new width of the stage as it scales
				var rescaleHeight = (desiredHeight / stageHeight);
				// Set a variable to calculate the new height of the stage as it scales
				var rescale = rescaleWidth;

				////////////console.log ('rescale', win.h, win.w, stageHeight * rescale > desiredHeight);

				if (stageHeight * rescale > desiredHeight){
				
				
				
				
				// Do not scale larger than the height of the browser window
					rescale = rescaleHeight;
					
					
				
					
					
				}
					//
					
					
			
			
				
				
						
				
					
			
					//topSpace=topSpace -(topSpace*rescale);
					
				
					

				stage.css('transform', 'scale(' + rescale + ')');
				stage.css('-o-transform', 'scale(' + rescale + ')');
				stage.css('-ms-transform', 'scale(' + rescale + ')');
				stage.css('-webkit-transform', 'scale(' + rescale + ')');
				stage.css('-moz-transform', 'scale(' + rescale + ')');
				stage.css('-o-transform', 'scale(' + rescale + ')');
				//parent.height(stageHeight * rescale);
				
				
				var mTop=    ((parentHeight - (stageHeight * rescale)) / 2);
				var mLeft=((parentWidth - (stageWidth * rescale)  ) / 2);
				
				
				/*if(Math.abs(mTop)===5.684341886080802e-14){
					
				//	console.log('fix', module)
					
				//	module.exports.scaleStage(id, w, h, rescaler);
					
					// scaleStage
					
					//parentHeight=parentHeight+45;
				//	mTop=    ((parentHeight - (stageHeight * rescale)) / 2);
					
					//mTop=0;
				}*/
				
				
				
				
				//console.log('fix2',  stageHeight*rescale  ,parentHeight  )
				
				if("topMarginPx" in rescaler &&   ( stageHeight*rescale )>=parentHeight  ){
					
					
					//console.log('fixX',  stageHeight*rescale  ,parentHeight  )
					
				if(!_.isUndefined( app.ViewType)){	
					if ( ('name' in  app.ViewType) ){
						
						
						if(app.ViewType.name==='yotta') {
							 mTop=    ((parentHeight - ((stageHeight-45) * rescale)) / 2);
							
							
						}
						
						
						
						
					}
					}
					
				 	
					
				}
				
				

				stage.css({
					'margin-top' :mTop+ 'px',
					'margin-left' : mLeft + "px"
				});
				
				
				//console.log ('HAVE H' ,id, parentHeight ,stageHeight, rescale, mTop, mLeft );
				
				
			}
		}
	};

});

